export const userRightsEnum = {
	COMPANYADMIN: "CompanyAdmin"
};
